var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "pricingTiers",
      staticClass: "sw-grid-flex sw-grid-flex--dir-column"
    },
    [
      _vm._l(_vm.tierDisplayOrder, function(tier, i) {
        return _c(
          "div",
          {
            key: "pricing-tier-" + (i + 1),
            staticClass: "card-wrapper",
            attrs: { id: "pricing-tier-" + (i + 1) }
          },
          [
            _c(
              "b-card",
              {
                class: {
                  "removed-tier": _vm.removedTiers.includes(
                    tier.pricingModelId
                  ),
                  "error-tier":
                    _vm.rangeOverlaps.includes(tier.tier) ||
                    _vm.rangeGaps.includes(tier.tier),
                  "new-tier": tier.pricingModelId === 0
                },
                attrs: {
                  title:
                    "Tier " +
                    tier.tier +
                    _vm.tierStatus(tier.pricingModelId, tier.tier)
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "form-section" },
                  [
                    _c("div", [
                      _c(
                        "select",
                        { staticClass: "sw-select--not-round sw--width-half" },
                        [
                          _c("option", { domProps: { value: 0 } }, [
                            _vm._v("No")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 1 } }, [
                            _vm._v("Yes")
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _vm._l(tier.inputs, function(item, index) {
                      return _c(
                        "div",
                        {
                          key: "pricing-input-" + index,
                          staticClass: "sw-grid-flex__cell-1-4 sw--padding-2",
                          class: _vm.removedTiers.includes(tier.pricingModelId)
                            ? "sw-dms--color-grey-64"
                            : ""
                        },
                        [
                          _c("h6", [_vm._v(_vm._s(item.text))]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.number",
                                value: item.value,
                                expression: "item.value",
                                modifiers: { number: true }
                              }
                            ],
                            staticClass:
                              "sw--input-height__medium sw--font-size-14 sw--width-full",
                            style:
                              !_vm.materialId ||
                              _vm.removedTiers.includes(tier.pricingModelId)
                                ? "color: #c7cdd0;"
                                : "",
                            attrs: {
                              type: "number",
                              step: "0.0001",
                              min: "0",
                              onfocus: "this.previousValue = this.value",
                              onkeydown: "this.previousValue = this.value",
                              oninput:
                                "(validity.valid || this.value === '') || (value = this.previousValue)",
                              required: "",
                              disabled:
                                !_vm.materialId ||
                                _vm.removedTiers.includes(tier.pricingModelId)
                            },
                            domProps: { value: item.value },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  item,
                                  "value",
                                  _vm._n($event.target.value)
                                )
                              },
                              blur: function($event) {
                                return _vm.$forceUpdate()
                              }
                            }
                          })
                        ]
                      )
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.tierInputs.length > 1 && tier.pricingModelId !== 0
                  ? _c(
                      "b-button",
                      {
                        staticClass: "card-btn",
                        attrs: { variant: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.removeTier(tier.pricingModelId)
                          }
                        }
                      },
                      [
                        !_vm.removedTiers.includes(tier.pricingModelId)
                          ? _c("span", [_vm._v("Remove")])
                          : _c("span", [_vm._v("Undo")])
                      ]
                    )
                  : _vm.tierInputs.length > 1
                  ? _c(
                      "b-button",
                      {
                        staticClass: "card-btn",
                        attrs: { variant: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.removeNewTier(tier.tier)
                          }
                        }
                      },
                      [_c("span", [_vm._v("Remove")])]
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      }),
      _vm._v(" "),
      _vm.showErrorModal
        ? _c("div", { staticClass: "modal-mask" }, [
            _c("div", { staticClass: "modal-wrapper" }, [
              _c("div", { staticClass: "modal-container" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _vm.rangeGaps.length
                    ? _c("div", [
                        _c("h6", [_vm._v("Range Gaps in following tiers")]),
                        _vm._v(" "),
                        _c(
                          "ul",
                          _vm._l(_vm.rangeGaps, function(tier) {
                            return _c("li", [_vm._v(_vm._s(tier))])
                          }),
                          0
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _vm.rangeOverlaps.length
                    ? _c("div", [
                        _c("h6", [_vm._v("Range Overlaps in following tiers")]),
                        _vm._v(" "),
                        _c(
                          "ul",
                          _vm._l(_vm.rangeOverlaps, function(tier) {
                            return _c("li", [_vm._v(_vm._s(tier))])
                          }),
                          0
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c("div", { attrs: { name: "footer" } }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "inline-flex",
                          "justify-content": "center",
                          width: "100%"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "cancel action-button",
                            on: {
                              click: function($event) {
                                _vm.showErrorModal = false
                              }
                            }
                          },
                          [_vm._v("Cancel")]
                        )
                      ]
                    )
                  ])
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("bottom-banner", {
        attrs: {
          "missing-info": !_vm.materialId ? ["Basic Information"] : [],
          "show-saved-message": _vm.showSavedMessage,
          "show-add-new-btn": _vm.showAddNewBtn
        },
        on: { saved: _vm.updateSubmissionData, "add-new": _vm.addNewTier }
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h3", [_vm._v("Please fix issues with tier ranges")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }